export const dragDropEndTrackEvent = ({
	source,
	contentStatus,
	pageId,
	previousParentPageId,
	newParentPageId,
	previousSpaceId,
	newSpaceId,
	referrer,
	isLivePage,
	isOnEditRoute,
	instructionType,
	isAmnPage = false,
}: {
	source: string;
	contentStatus: string | null;
	pageId: string;
	previousParentPageId: string;
	newParentPageId: string;
	previousSpaceId: string | undefined | null;
	newSpaceId: string | undefined | null;
	referrer?: string;
	isLivePage?: boolean; //TODO optional for pageTree
	isOnEditRoute?: boolean;
	instructionType?: string;
	isAmnPage?: boolean;
}): {
	type: string;
	data: {
		action: string;
		source: string;
		containerType: string;
		containerId: string | null | undefined;
		objectType: string;
		objectId: string;
		actionSubject: string;
		attributes: {
			isLivePage: boolean | undefined;
			isOnEditRoute: boolean | undefined;
			instructionType: string | undefined;
			isAmnPage: boolean;
			referrer?: string | undefined;
			contentStatus: string | null;
			previousSpaceId: string | null | undefined;
			previousParentPageId: string;
			newSpaceId: string | null | undefined;
			newParentPageId: string;
		};
	};
} => ({
	type: 'sendTrackEvent',
	data: {
		action: 'updated',
		source,
		containerType: 'space',
		containerId: previousSpaceId,
		objectType: 'page',
		objectId: pageId,
		actionSubject: 'page',
		attributes: {
			contentStatus: contentStatus ?? null,
			previousSpaceId,
			previousParentPageId,
			newSpaceId,
			newParentPageId,
			...(referrer ? { referrer } : undefined),
			isLivePage,
			isOnEditRoute,
			instructionType,
			isAmnPage,
		},
	},
});

export const dragStartUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'dragged',
		actionSubject: 'pageTree',
		source: 'viewPageScreen',
	},
});

export const dragEndUIEvent = (
	isValidTarget: any,
): {
	type: string;
	data: {
		action: string;
		actionSubject: string;
		source: string;
		attributes: {
			isValidTarget: any;
		};
	};
} => ({
	type: 'sendUIEvent',
	data: {
		action: 'dropped',
		actionSubject: 'pageTree',
		source: 'viewPageScreen',
		attributes: {
			isValidTarget,
		},
	},
});

export const undoClickUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'clicked',
		actionSubject: 'button',
		actionSubjectId: 'pageTreeDragDropUndo',
		source: 'viewPageScreen',
	},
});

export const undoShortcutUIEvent = () => ({
	type: 'sendUIEvent',
	data: {
		action: 'pressed',
		actionSubject: 'keyboardShortcut',
		actionSubjectId: 'pageTreeDragDropUndo',
		source: 'viewPageScreen',
	},
});

export const pageTreeUIAnalytics = (
	action: any,
	spaceId: any,
	isInDrawer: any,
	status?: any,
	contentId?: any,
	contentType?: any,
	navdexPointType?: any,
	isOnEditRoute?: any,
	contentTreeSize?: any,
	spaceKey?: any,
): {
	type: string;
	data: {
		containerType: string;
		containerId: any;
		objectType: any;
		objectId: any;
		action: any;
		actionSubject: string;
		source: string;
		attributes: {
			navigationLayer: string;
			navigationContainer: string;
			spaceView: string;
			contentStatus: any;
			isOnEditRoute: any;
			contentTreeSize: any;
			navVersion: string;
			spaceKey: any;
		};
	};
} => {
	const event = {
		type: 'sendUIEvent',
		data: {
			containerType: 'space',
			containerId: spaceId,
			objectType: contentType ?? 'page',
			objectId: contentId ?? '',
			action,
			actionSubject: 'pageTree',
			source: isInDrawer ? 'pageTreeDrawer' : 'containerNavigation',
			attributes: {
				navigationLayer: 'container',
				navigationContainer: 'sidebar',
				spaceView: 'TREE',
				contentStatus: status ?? null, // status/contentStatus is used to distinguish published page vs draft when clicking on a page tree item
				isOnEditRoute,
				contentTreeSize,
				navVersion: '4',
				spaceKey,
			},
		},
	};
	if (navdexPointType) {
		event.data.attributes['navdexPointType'] = navdexPointType;
	}
	return event;
};

export const pageTreePaginationEvent = (
	spaceId?: any,
	pageCount?: any,
	source?: any,
	direction?: any,
): {
	type: string;
	data: {
		action: string;
		containerId: any;
		actionSubject: string;
		actionSubjectId: string;
		source: any;
		attributes: {
			pageCount: any;
			direction: any;
		};
	};
} => ({
	type: 'sendUIEvent',
	data: {
		action: 'clicked',
		containerId: spaceId,
		actionSubject: 'button',
		actionSubjectId: 'showAllButton',
		source: source || 'containerNavigation',
		attributes: {
			pageCount,
			direction,
		},
	},
});

export const oneOnOnePagesDetectedEvent = (
	oneOnOnePagesCount: number,
	totalPagesCount: number,
	spaceId?: string,
): {
	type: string;
	data: {
		action: string;
		actionSubject: string;
		actionSubjectId: string;
		source: string;
		containerType: string;
		containerId: string | undefined;
		attributes: {
			oneOnOnePagesCount: number;
			totalPagesCount: number;
		};
	};
} => ({
	type: 'sendTrackEvent',
	data: {
		action: 'OneOnOneTitlesShown',
		actionSubject: 'pageTree',
		actionSubjectId: 'OneOnOneTitles',
		source: 'containerNavigation',
		containerType: 'space',
		containerId: spaceId,
		attributes: {
			oneOnOnePagesCount,
			totalPagesCount,
		},
	},
});
